var exports = {
  "M0": "x804f0401--87621f--bar",
  "Z3": "x804f0401--87621f--bar-filler",
};

module.exports = exports;
